import {
  fetchSummaryCollapseStatus,
  saveSummaryCollapseStatus,
} from '../routines';

import {
  ORGANIZATION,
  ACCOUNT,
  CONTACT,
} from '../../common/constants/TableColumnScopeConstants';

const initialState = {
  [ORGANIZATION]: false,
  [ACCOUNT]: false,
  [CONTACT]: false,
};

const summaryCollapseStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchSummaryCollapseStatus.SUCCESS:
    case saveSummaryCollapseStatus.SUCCESS: {
      const { scope, status } = action.payload;
      return {
        ...state,
        [scope]: status,
      };
    }
    default:
      return state;
  }
};

export default summaryCollapseStatusReducer;
